<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .range-input {
    display: flex;
    flex-direction: row;
    gap: utils.in_rem(16px);
    align-items: center;

    .input {
      width: utils.in_rem(200px);
    }

    .range-divider {
      margin-top: utils.in_rem(22px);
    }
  }
</style>

<script>
  import TextInput from "@sourcewhale/shared/svelte-design-system/components/molecules/InputFields/TextInput.svelte";
  import { editContactStore } from "../../../stores";

  let { label, id } = $props();
</script>

<div class="range-input">
  <div class="input">
    <TextInput
      label={label + " (min)"}
      bind:value={$editContactStore[`${id}Min`]}
    />
  </div>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="2"
    viewBox="0 0 10 2"
    fill="none"
    class="range-divider"
  >
    <path d="M0 1H10" stroke="#747474" />
  </svg>
  <div class="input">
    <TextInput
      label={label + " (max)"}
      bind:value={$editContactStore[`${id}Max`]}
    />
  </div>
</div>
